import { useState } from "react";

import useChangeUserPasswordRequest from "../../hooks/useChangeUserPasswordRequest";
import { ResetPasswordUserFormView } from "./RssetPasswordRequestFormView";

import ValidatedStateDisplay from "../../../../common/components/organisme/ValidatedStateDisplay/ValidatedStateDisplay";
import useNavigationApp from "../../../../navigation/useNavigationApp";
import inputValidityChecker from "../../../../utils/inputValidityChecker";

export interface FormDataResetPasswordRequest {
  email?: string;
}

export interface ErrorStatusResetPasswordRequest {
  isErrorEmail: boolean;

  allValid?: boolean;
  messageError?: string;
}

const checkValidity = (formData: FormDataResetPasswordRequest) => {
  const isErrorStatus: ErrorStatusResetPasswordRequest = {
    isErrorEmail: false,
    allValid: true,
    messageError: "",
  };

  let messageError: string[] = [];

  if (!formData.email || !inputValidityChecker.validateEmail(formData.email)) {
    isErrorStatus.isErrorEmail = true;
    isErrorStatus.allValid = false;
    messageError.push("Veuillez saisir un email valide");
  }

  if (messageError.length > 0) {
    isErrorStatus.messageError = messageError.join(", ");
  }

  return isErrorStatus;
};

const INITIAL_IS_VALID_STATUS: ErrorStatusResetPasswordRequest = {
  isErrorEmail: false,
  allValid: true,
  messageError: "",
};
export const ResetUserPasswordRequestFormPresenter = () => {
  const { createChangeUserPassword } = useChangeUserPasswordRequest();
  const [formData, setFormData] = useState<FormDataResetPasswordRequest>({
    email: undefined,
  });
  const [errorStatus, setErrorStatus] =
    useState<ErrorStatusResetPasswordRequest>({
      isErrorEmail: false,
      allValid: true,
      messageError: "",
    });

  const navigate = useNavigationApp();

  const [isDone, setIDone] = useState(false);
  const handleSetFormData = (
    key: keyof FormDataResetPasswordRequest,
    value: string
  ) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  if (isDone) {
    return (
      <ValidatedStateDisplay
        validationMessage="Votre demande de réinitialisation de mot de passe a été envoyée avec succès"
        labelBtn="Accueil"
        onClickBtn={() => {
          navigate.goToHome();
        }}
        marginLeft="-20%"
      />
    );
  }

  const handleSendRequest = () => {
    const isErrorStatus = checkValidity(formData);

    if (!isErrorStatus.allValid) {
      setErrorStatus(isErrorStatus);
      return;
    }

    if (formData.email) {
      createChangeUserPassword.mutate({
        email: formData.email,
        callback: (response) => {
          if (response.result) {
            setIDone(true);
          }

          if (response.error) {
            setErrorStatus({
              ...INITIAL_IS_VALID_STATUS,
              messageError: response.error.message || "Une erreur est survenue",
            });
          }
        },
      });
    }
  };

  const onClickCancel = () => {
    navigate.goToHome();
  };

  return (
    <ResetPasswordUserFormView
      title="Demande de réinitialisation de mot de passe"
      description="Veuillez entrer votre adresse email pour recevoir un lien de réinitialisation de mot de passe."
      submitLabel="Envoyer la demande"
      formData={formData}
      setFormData={handleSetFormData}
      errorStatus={errorStatus}
      handleSubmit={handleSendRequest}
      messageError={errorStatus.messageError}
      isLoading={createChangeUserPassword.isLoading}
      onClickCancel={onClickCancel}
      maxWidth="400px"
    />
  );
};
